import { render, staticRenderFns } from "./NoteGeneral.vue?vue&type=template&id=54028be3&scoped=true"
import script from "./NoteGeneral.vue?vue&type=script&lang=js"
export * from "./NoteGeneral.vue?vue&type=script&lang=js"
import style0 from "./NoteGeneral.vue?vue&type=style&index=0&id=54028be3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54028be3",
  null
  
)

export default component.exports